import React from 'react'

import styles from './container.module.css'

export default ({ children, narrow }) => (
  <div className={styles.container} style={{
    maxWidth: narrow && "800px"
  }} >{children}</div>
)
